import React from 'react';
import $ from "jquery";
var striptags = require('striptags');



class AdditionalQuestionOptions extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            disabledNext:false,
            selectedAns:true,
           /* selectedAdditionalResult:[],*/
            additionalSelectedAnswerKey:'',
            additionalSelectedAnswer:'',
        }
    }
/*
    componentDidUpdate(){
        console.log('updating addiotnal')
       /!* if(this.props.multipleQ=="1") {*!/
            let elements = this.resultAdditionalAns.children;
            for (let i = 0; i < elements.length; i++) {
                if (elements[i].hasAttribute('checked')) {
                    let selectedAdditionalResult = this.state.selectedAdditionalResult.slice();
                    selectedAdditionalResult.push(elements[i].innerHTML);
                    this.setState({selectedAdditionalResult: selectedAdditionalResult});

                    elements[i].removeAttribute('checked')
                }
            }
      /!*  }else{

        }*!/

    }*/
    handleScroll(event) {
        console.log('hi')
        this.resultAdditionalAns.style.bottom = "0px";
        /*if(window.pageYOffset === 0) {
            /!*  this.quizHeader.style.transition = "top 3s ease-out"*!/
            this.resultDreiAns.style.bottom = null;

        }else {
            /!*  this.quizHeader.style.transition = "top 3s ease-out"*!/


        }*/
    }
    _getSelectedResult(){
        this.props.setAdditionalResult(this.state.additionalSelectedAnswer,this.state.additionalSelectedAnswerKey)
        //window.addEventListener('scroll', this.handleScroll.bind(this));
        $('html,body').animate({
                scrollTop: $(document).height()},
            'slow');
    }
    selectAdditionalAnswer(e){
        let elements  = this.resultAdditionalAns.children;
        for(let i=0;i<elements.length;i++){
            if(e.target === elements[i]){
                elements[i].setAttribute('checked',true)
                elements[i].setAttribute('class','col-options3 selected')
                this.setState({additionalSelectedAnswerKey:e.target.value});
                this.setState({additionalSelectedAnswer:elements[i].innerHTML});
                setTimeout(()=> {
                    this._getSelectedResult();
                },100)
            }else{
                /* elements[i].setAttribute('checked', false)*/
                elements[i].removeAttribute('checked')
                elements[i].setAttribute('class','col-options3')
            }
        }
    }
    render(){
     /*   console.log('in additional options')
        console.log(this.props.frageOptions)
        this.props.frageOptions.map((option,key)=> {
             console.log(option)
        });*/
       /* console.log(this.state.selectedAdditionalResult)*/
        let quizOptions;
      /*  if(this.props.frageOptions.length === 2){

            quizOptions = this.props.frageOptions.map((option,key)=>{
                let strippedOption = striptags(option).toString();
                let id= parseInt(key)+1;

                /!*console.log(this.state.selectedAns)*!/
                return (

                    <li
                        key={id}
                        className=""
                        onClick={this.selectAnswer.bind(this)}
                        checked={false}
                    >
                        {strippedOption}
                    </li>


                );
            });
        }else{*/
            quizOptions = this.props.frageOptions.map((option,key)=>{
              /*  console.log(option)*/
                let strippedOption = striptags(option[1]).toString();
                let id= parseInt(key)+1;
                return (
                    <li
                        key={option[0]}
                        value={option[0]}
                        className="col-options3"
                        onClick={this.selectAdditionalAnswer.bind(this)}
                        checked={false}
                    >
                        {strippedOption}
                    </li>

                );
            });

       /* }*/
 /*       if(this.props.frageOptions.length === 2) {
            return (
                <div className="questionOptions zweiOptions">
                    <ul  ref={input => {
                        this.resultAns = input;
                    }} >
                        {quizOptions}
                    </ul>
                </div>
            );
        }else{*/

            if(this.props.frageOptions[0][1].length> 20) {
                return (
                    <div className="additional questionOptions dreiOptionsFullWidth centered">
                        <ul ref={input => {
                            this.resultAdditionalAns = input;
                        }} >
                            {quizOptions}
                        </ul>
                    </div>
                );
            }else {
                return (
                    <div className="additional questionOptions dreiOptions">
                        <ul ref={input => {
                            this.resultAdditionalAns = input;
                        }} >
                            {quizOptions}
                        </ul>
                    </div>
                );
            }
       /* }*/
    }
}
export default AdditionalQuestionOptions;

